import type { OrderStatus } from "@school-sales-ai/shared";
import { ORDER_STATUS_META } from "@/lib/order-status-meta";
import { cn } from "@/lib/utils";

export function OrderStatusBadge({ status }: { status: OrderStatus }): React.JSX.Element {
  const meta = ORDER_STATUS_META[status];
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-[11.5px] font-medium",
        meta?.className ?? "bg-ink-050 text-ink-600",
      )}
    >
      {/* A status from a newer build renders as its raw value rather than as a
          blank chip: `status` is a VarChar precisely so the vocabulary can grow. */}
      {meta?.label ?? status}
    </span>
  );
}
